import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    @font-face {
    font-family: 'BMJUA';
    src: url('/static/font/BMJUA_otf.otf');
    }
    @font-face {
    font-family: 'Cafe24Ohsquareair';
    src: url('/static/font/Cafe24Ohsquareair.ttf');
    }
    @font-face {
    font-family: 'Spoqa Han Sans Neo';
    src: url('/static/font/SpoqaHanSansNeo-Regular.otf');
    }
`;
